import './style.scss'
import * as THREE from 'three'
// import LocomotiveScroll from 'locomotive-scroll';
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import * as dat from 'dat.gui'
import VertexShader from './shaders/test/vertex.glsl'
import FragmentShader from './shaders/test/fragment.glsl'
// import noiseVertexShader from './shaders/noise/vertex.glsl'
// import noiseFragmentShader from './shaders/noise/fragment.glsl'
// import createjs from 'preload-js'
// import gsap from 'gsap'
// import { TimelineMax, CSSRulePlugin } from "gsap/all"
// gsap.registerPlugin(CSSRulePlugin)
// import LocomotiveScroll from 'locomotive-scroll';
// import * as Matter from 'matter-js'
// import barba from '@barba/core'

import { SmoothScroll } from './native.smooth.scroll.js';

const smoothScroll = new SmoothScroll({
  container: document.querySelector(".container"),
  // round the threshold to 1 pixel
  threshold: 1,
  // use built-in raf loop
  useRaf: true
})

window.addEventListener("resize", () => {
  smoothScroll.resize()
})


const toggleClass = (element, stringClass) => {
  if (element.classList.contains(stringClass))
    element.classList.remove(stringClass)
  else
    element.classList.add(stringClass)
}

const removeClass = (element, stringClass) => {
  if (element.classList.contains(stringClass)) {
    element.classList.remove(stringClass)
  }
}

/**-------------------------------------------------------------------------------------------------------------
 * Preload JS
 -------------------------------------------------------------------------------------------------------------*/

// var queue = new createjs.LoadQueue(false)

// queue.on("progress", event => {
//   console.log(event)
// })

// queue.on("fileload", handleFileComplete)
// queue.loadFile("./images/photo-tonio.png")

// function handleFileComplete(event) {
//   console.log('vier')
// }

/**-------------------------------------------------------------------------------------------------------------
 * Transition
 -------------------------------------------------------------------------------------------------------------*/

const transition = document.querySelector('.barbatransition')
const linkIndex = document.querySelector('#linkindex')
const linkIndex1 = document.querySelector('#linkindex1')
const linkWorks = document.querySelector('#linkworks')
const linkContact = document.querySelector('#linkcontact')
const link3d = document.querySelector('#link3d')
const linktlz = document.querySelector('#linktlz')
const linkairmob = document.querySelector('#linkairmob')
const linkvideo = document.querySelector('#linkvideo')
const linkschool = document.querySelector('#linkschool')
// const link3d1 = document.querySelector('#link3d')//on works page
// const linktlz1 = document.querySelector('#linktlz')//on works page
// const linkairmob1 = document.querySelector('#linkairmob')//on works page
// const linkvideo1 = document.querySelector('#linkvideo')//on works page
// const linkschool1 = document.querySelector('#linkschool')//on works page

linkIndex1.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./index.html", 1250)
})

linkIndex.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./index.html", 1250)
})

linkWorks.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./work.html", 1250)
})

linkContact.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./contact.html", 1250)
})

link3d.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./work-3d.html", 1250)
})

linktlz.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./work-tlz.html", 1250)
})

linkairmob.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./work-airmob.html", 1250)
})

linkvideo.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./work-videography.html", 1250)
})

linkschool.addEventListener('click', () => {
  toggleClass(transition, 'barbatransitionenter')
  setTimeout(document.location.href = "./work-schoolwork.html", 1250)
})

// link3d1.addEventListener('click', () => {
//   toggleClass(transition, 'barbatransitionenter')
//   setTimeout(document.location.href = "./work-3d.html", 1250)
// })

// linktlz1.addEventListener('click', () => {
//   toggleClass(transition, 'barbatransitionenter')
//   setTimeout(document.location.href = "./work-tlz.html", 1250)
// })

// linkairmob1.addEventListener('click', () => {
//   toggleClass(transition, 'barbatransitionenter')
//   setTimeout(document.location.href = "./work-airmob.html", 1250)
// })

// linkvideo1.addEventListener('click', () => {
//   toggleClass(transition, 'barbatransitionenter')
//   setTimeout(document.location.href = "./work-videography.html", 1250)
// })

// linkschool1.addEventListener('click', () => {
//   toggleClass(transition, 'barbatransitionenter')
//   setTimeout(document.location.href = "./work-schoolwork.html", 1250)
// })

window.onload = removeClass(transition, 'barbatransitionenter')

// function delay(n) {
//   return new Promise((done) => {
//     setTimeout(() => {
//       done()
//     }, n)
//   })
// }

// barba.init({

//   sync: true,

//   transitions: [
//     {
//       async leave() {

//         const done = this.async()

//         // TLAnim.set(transition, { zIndex: '99' })
//         TLAnim
//           .set(transition, { left: '0%' })
//           .to(transition, { opacity: 1, ease: "power2.out", duration: 0.6 })

//         await delay(1000)
//         done()

//       },
//       enter() {

//         TLAnim
//           .set(transition, { left: '0%' })
//           .set(transition, { opacity: 1 })
//           .to(transition, { opacity: 0, ease: "power2.out", duration: 0.6 })
//           .to(transition, { left: '-100%', ease: "power2.out", duration: 0.01, delay: 0.65 })

//       }
//     }
//   ],
//   views: [{
//     namespace: 'home',
//     beforeEnter({ next }) {
//       // load your script
//       let script = document.createElement('script')
//       script.src = './script.js' // location of your js file
//       next.container.appendChild(script)
//     },
//   }],
// })

// barba.init({
//   sync: true,
//   views: [
//     {
//       namespace: 'home', //specify the barba namespace you indicated in your HTML
//       beforeEnter({ next }) { //before entering the next page and if it contains the 'home-section' namespace
//         // NOTE: You need to create individual script variables for each script you're going to load and add them one by one.
//         let script = document.createElement('script') //create a script element
//         script.src = './script.js' //specify the directory of the script you want to load
//         next.container.appendChild(script) //this adds the script tag you created to the 'container' of this page
//       },
//     },
//   ],
//   transitions: [
//     {
//       async leave() {

//         const done = this.async()

//         // TLAnim.set(transition, { zIndex: '99' })
//         TLAnim
//           .set(transition, { left: '0%' })
//           .to(transition, { opacity: 1, ease: "power2.out", duration: 0.9 })

//         await delay(1500)
//         done()

//       },
//       enter() {

//         TLAnim
//           .set(transition, { left: '0%' })
//           .set(transition, { opacity: 1 })
//           .to(transition, { opacity: 0, ease: "power2.out", duration: 0.9 })
//           .to(transition, { left: '-100%', ease: "power2.out", duration: 0.01, delay: 0.95 })

//       }
//     }
//   ],
// })


/**-------------------------------------------------------------------------------------------------------------
 * Images Иои
------------------------------------------------------------------------------------------------------------- */

// var anime02 = document.querySelector('.my-face')
// anime02.setAttribute("src", "./images/photo-tonio.png")

/**-------------------------------------------------------------------------------------------------------------
 * Moving text
 -------------------------------------------------------------------------------------------------------------*/
let page = window.location.href

// if (page === '/contact' || page === '/index' || page === '/work') { for dev only
if (page === 'https://antoine-galy-foliov1.netlify.app/' || page === 'https://antoine-galy-foliov1.netlify.app/work.html' || page === 'https://antoine-galy-foliov1.netlify.app/contact.html' || page === 'https://antoine-galy-foliov1.netlify.app/index.html') {

  let textAntoine = document.querySelector('.sprat-webgl')

  // function lerp(start, end, amount) {
  //   return ((1 - amount) * start + amount * end).toFixed(2)
  // }

  document.addEventListener("mousemove", (e) => {
    let mousex = e.clientX // Gets Mouse X.
    // let mousey = e.clientY // Gets Mouse Y.
    if (window.innerWidth > 1024) {
      textAntoine.style.transform = "translateX(" + -(mousex / window.innerWidth) * (window.innerWidth - window.innerWidth / 2.573) + "px)"
    }
    // translateY(" + mousey * 0.07 + 100 + "px)
  })
}



/**
 * Menu
 */
let html = document.querySelector('html')
let nav = document.querySelector('nav')
let navItems = document.querySelector('.nav-items a')
let menuButton = document.querySelector('.menu-toggler')

menuButton.addEventListener('click', () => {
  toggleClass(html, 'menu-overflow-hidden')
  toggleClass(menuButton, 'open')
  toggleClass(nav, 'toggle')
})


/**
 * Base
 */
// Debug
// const gui = new dat.GUI()

// const settings = {
//   speed: 0.2,
//   density: 1.5,
//   strength: 0.2,
//   frequency: 3.0,
//   amplitude: 0.5,
//   intensity: 4.0,
// }

// const folder1 = gui.addFolder('Noise')
// const folder2 = gui.addFolder('Rotation')
// const folder3 = gui.addFolder('Color')
// folder1.add(settings, 'speed', 0.1, 1, 0.01)
// folder1.add(settings, 'density', 0, 10, 0.01)
// folder1.add(settings, 'strength', 0, 2, 0.01)
// folder2.add(settings, 'frequency', 0, 10, 0.1)
// folder2.add(settings, 'amplitude', 0, 10, 0.1)
// folder3.add(settings, 'intensity', 0, 10, 0.1)

// Canvas
const canvas = document.querySelector('.webgl')

// Scene
const scene = new THREE.Scene()


/**
 * Mesh
 */
// Geometry
const geometryBlob = new THREE.IcosahedronBufferGeometry(1, 64)

// Shader material
const materialBlob = new THREE.ShaderMaterial({
  uniforms: {
    uTime: { value: 0 },
    uSpeed: { value: 0.2 },
    uNoiseDensity: { value: 1.5 },
    uNoiseStrength: { value: 0.3 },
    uFrequency: { value: 3.0 },
    uAmplitude: { value: 2.0 },
    uIntensity: { value: 4.0 },
  },
  vertexShader: VertexShader,
  fragmentShader: FragmentShader
})

// Mesh
const meshBlob = new THREE.Mesh(geometryBlob, materialBlob)
scene.add(meshBlob)


/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
}

if (window.innerWidth < 1024) {
  let differenceWidth = ((window.innerHeight / window.innerWidth) * 2)
  sizes.width = window.innerWidth
  sizes.height = (sizes.width / 16) * (9 + differenceWidth)
} else {
  sizes.width = window.innerWidth
  sizes.height = ((sizes.width / 16) * 9)
}

window.addEventListener('resize', () => {
  // Update sizes
  if (window.innerWidth < 1024) {
    let differenceWidth = ((window.innerHeight / window.innerWidth) * 2)
    sizes.width = window.innerWidth
    sizes.height = (sizes.width / 16) * (9 + differenceWidth)
  } else {
    sizes.width = window.innerWidth
    sizes.height = ((sizes.width / 16) * 9)
  }

  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(60, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0, 0, 3.5)
scene.add(camera)

//Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas, antialias: true, alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
  const elapsedTime = clock.getElapsedTime()

  // Update controls
  // controls.update()

  // Update Scroll
  smoothScroll.update()

  // Update uniforms
  materialBlob.uniforms.uTime.value = elapsedTime
  // noisePass.uniforms.uTime.value = elapsedTime
  // materialBlob.uniforms.uSpeed.value = settings.speed
  // materialBlob.uniforms.uNoiseDensity.value = settings.density
  // materialBlob.uniforms.uNoiseStrength.value = settings.strength
  // materialBlob.uniforms.uNoiseStrength.value = settings.frequency
  // materialBlob.uniforms.uNoiseStrength.value = settings.amplitude
  // materialBlob.uniforms.uIntensity.value = settings.intensity
  // Render
  renderer.render(scene, camera)

  // Call tick again on the next frame
  window.requestAnimationFrame(tick)
}

tick()

/** Smooth Scroll */



